// LoadingSpinner.js
import React from "react";
import "./LoadingSpinner.css"; // وارد کردن استایل CSS

const LoadingSpinner = () => {
  return (
    <div className="loading-container">
      <div className="spinner">
        <div className="circle"></div>
        <div className="text">
          <span className="okr">OKR</span>
          <span>Coach</span>
        </div>
      </div>
    </div>
  );
};

export default LoadingSpinner;
